import { useContext } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import LockIcon from "@mui/icons-material/Lock";
import MainContext from "../../context/mainContext";

function AccessDeny() {
  const { handleOpenSignInBox, userTypes, videoInfo } = useContext(MainContext);

  return (
    <>
      <Container maxWidth="md" component="main" sx={{ height: "100vh" }}>
        <Grid sx={{ mt: "auto" }} container spacing={5} alignItems="flex-end">
          <Grid
            item
            xs={12}
            sm={"title" === "Enterprise" ? 12 : 6}
            md={5}
            sx={{ mx: "auto", my: "auto" }}
          >
            <Card>
              <Box
                sx={{
                  backgroundColor: (theme) =>
                    theme.palette.mode === "light"
                      ? theme.palette.grey[200]
                      : theme.palette.grey[700],
                  mx: "auto",
                  px: "auto",
                }}
              >
                <Box sx={{ textAlign: "center", color: "#ed4f4f", height: 80 }}>
                  <LockIcon
                    sx={{ textAlign: "center", height: "100%", width: "100%" }}
                  />
                </Box>{" "}
              </Box>
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "baseline",
                    mb: 2,
                  }}
                >
                  <Typography
                    component="h5"
                    variant="h5"
                    color="text.primary"
                    sx={{ textAlign: "center" }}
                  >
                    برای ورود به این بخش لطفا وارد برنامه شوید
                  </Typography>
                </Box>
              </CardContent>
              <CardActions>
                <Button
                  onClick={handleOpenSignInBox}
                  variant="contained"
                  fullWidth
                  color="info"
                  sx={{ fontSize: 25 }}
                >
                  ورود / ثبت نام
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default AccessDeny;
